// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/sumTotal/css/style.less
// module id = 2277
// module chunks = 0